import { createFileRoute } from '@tanstack/react-router';
import { SegmentUsageRoute } from './-route-wrappers';

/**
 * A segment's Usage tab at its own URL. No `appBundle`: this URL has no `journeys` segment for the
 * resolver to rebuild a target from. The resolver runs in
 * `SegmentUsageRoute`.
 */
function SegmentUsageTabRoute() {
  const { segmentId } = Route.useParams();

  return <SegmentUsageRoute segmentId={segmentId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/segments/$segmentId/usage')({
  component: SegmentUsageTabRoute,
});
